import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';

import { NoticeType } from 'stores/NoticeAdminStoreAdapter';
import { UserNoticeGroupResult, listUserNotice } from 'stores/NoticeStoreAdapter';

export type NoticeCounts = Record<NoticeType, number>;

type NoticeCountContextType = {
  counts: NoticeCounts;
  refresh: () => void;
};

const defaultCounts: NoticeCounts = {
  NOTICE: 0,
  INFO: 0,
  IMPORTANT: 0,
  SECURITY_CHECK: 0,
};

const NoticeCountContext = createContext<NoticeCountContextType>({
  counts: defaultCounts,
  refresh: () => {},
});

export const useNoticeCount = () => useContext(NoticeCountContext);

type NoticeCountProviderProps = {
  children: React.ReactNode;
};

export const NoticeCountProvider: React.FC<NoticeCountProviderProps> = ({ children }) => {
  const [counts, setCounts] = useState<NoticeCounts>(defaultCounts);

  const refresh = useCallback(() => {
    listUserNotice({ isResolved: false })
      .then((results: UserNoticeGroupResult[]) => {
        const newCounts: NoticeCounts = { NOTICE: 0, INFO: 0, IMPORTANT: 0, SECURITY_CHECK: 0 };
        results.forEach((group) => {
          newCounts[group.noticeType] = group.notices?.filter((n) => n.isNew).length || 0;
        });
        setCounts(newCounts);
      })
      .catch(() => {
        // サイレントフェイル（バッジ更新失敗は致命的ではない）
      });
  }, []);

  useEffect(() => {
    refresh();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <NoticeCountContext.Provider value={{ counts, refresh }}>
      {children}
    </NoticeCountContext.Provider>
  );
};
